module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {}, [_c('div', {
    staticClass: "nodata flex justify-center align-center flex-direction"
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "src": "/static/assets/images/empty.png"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.text) + "\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39f59f5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nomore.vue
// module id = 394
// module chunks = 1